<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
      <el-form-item label="功能">
        <el-select v-model="formLabelAlign.func_config_id" placeholder="请选择" @change="functionclick">
          <el-option
            v-for="(item) in options"
            :key="item.id"
            :label="item.func_desc + '(' + item.file_name +')'"
            :value="item.id"
          />
        </el-select>

      </el-form-item>
      <el-form-item label="版本">
        <el-input v-model="formLabelAlign.version_num" placeholder="请输入版本" />
      </el-form-item>
      <el-form-item label="文件地址">
        <el-tag v-if="file_namesuccess!=''" style="margin-right:10px">{{ file_namesuccess }}</el-tag>
        <el-button type="primary" size="mini" :disabled="formLabelAlign.func_config_id=='' || formLabelAlign.version_num==''" class="button upload inrew" @click="$refs.file.click()">
          <span>上传文件</span>
          <input ref="file" style="display:none;" type="file" class="file" @change="myChange">
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { createOta, updataOta, getOtaConfigList } from '@/api/sourceMaterial.js'
import * as qiniu from 'qiniu-js'
import { qiniuToken } from '@/api/qiniuToken'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      type: null,
      formLabelAlign: {
        func_config_id: '',
        version_num: '',
        file_url: ''
      },
      options: [],
      item: {},
      id: null,
      token: null,
      file_name: '',
      file_namesuccess: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    getQiniuToken() {
      qiniuToken().then(res => {
        this.token = res.data.upToken
      })
    },
    send(item, type) {
      this.getfunction()
      this.getQiniuToken()
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        this.type = type
      } else {
        this.type = type
        this.formLabelAlign.func_config_id = item.func_config_id
        this.formLabelAlign.version_num = item.version_num
        this.formLabelAlign.file_url = item.file_url
        this.id = item.id
      }
    },
    async getfunction() {
      const data = await getOtaConfigList({
        page: 1,
        page_size: 1000
      })
      this.options = data.data.list
      console.log('data', data)
    },
    myChange(event) {
      // const sizemb = (event.target.files[0].size / 1024).toFixed(3)
      // const size = size / 1024// kb
      // size = (size / 1024).toFixed(3)// mb
      const file = event.target.files[0] // 文件信息对象
      // if (file.size > 400000) {
      //   this.$message({
      //     message: '图片必须小于50kb',
      //     type: 'error'
      //   })
      //   return
      // }
      // // 判断是否符合尺寸条件
      // this.isLimitSize(file, 512, 512).then(res => {
      //   this.randomName(file)
      // })

      this.randomName(file)
    },
    randomName(file) {
      console.log('6666', this.file_name, file.name)
      // eslint-disable-next-line eqeqeq
      if (this.file_name != file.name) {
        this.$message({
          message: '请上传相同文件的进行上传',
          type: 'error'
        })
        return
      }
      const filename = file.name
      const url = window.URL.createObjectURL(file)
      const fsuiji = Math.random().toString(36).slice(-4) // 随机4位字符串
      const ftype = file.name.substr(file.name.lastIndexOf('.')) // 截取文件格式
      const fname = file.name.substring(0, file.name.lastIndexOf('.')) // 截取文件名
      const timeStamp = new Date() - 0 // 时间戳
      console.log(fsuiji, ftype, fname, timeStamp, file.name)
      this.isUpload = true
      this.temporaryAddress = url
      this.uploadFile({
        filename,
        file,
        // fileName: 'user/' + fname + '_' + timeStamp + '_' + fsuiji + ftype, // 组合随机文件名
        fileName: 'ota/' + file.name + '_' + this.formLabelAlign.version_num, // 组合随机文件名
        token: this.token,
        putExtra: {
          fname: file.name // 文件名
        },
        config: {
          useCdnDomain: true // cdn域名加速
        }
      })
    },
    // 上传文件
    uploadFile({ filename, file, fileName, token, putExtra = {}, config = {}}) {
      const vm = this
      const observable = qiniu.upload(file, fileName, token, putExtra, config)
      const subscription = observable.subscribe({
        next() {},
        error(err) {
          console.log(err, '====')
          vm.$message({
            message: '上传失败，功能文件未更新',
            type: 'error'
          })
        },
        complete: (data) => {
          console.log('data', data)
          this.file_namesuccess = filename
          this.formLabelAlign.file_url = data.key
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          // const sizekb = Math.ceil(file.size / 1024)
          // // const type = file.type
          // const img = new Image()
          // img.src = window.URL.createObjectURL(file)
          // img.onload = function() {
          //   const query = {
          //     width: img.width,
          //     height: img.height,
          //     size: sizekb,
          //     type: 1,
          //     key: data.key
          //   }
          //   console.log('img.src', img.src, data.key, query)
          //   vm.imgSrc = img.src
          //   vm.qrcode_url = data.key
          //   // vm.brandImageParams.file = query.key
          // }
        }
      }) // 上传开始
      // return subscription.unsubscribe // 返回一个取消上传的方法
      console.log(subscription)
    },
    functionclick(val) {
      console.log('val', val)
      var arrindex = this.options.findIndex((item) => {
        // eslint-disable-next-line eqeqeq
        return item.id == val
      })
      this.file_name = this.options[arrindex].file_name
      console.log('arrindex', arrindex)
    },
    async sumbit() {
      if (this.formLabelAlign.func_config_id === '') {
        this.$message({
          message: '请选择功能',
          type: 'error'
        })
        return
      }
      if (this.formLabelAlign.version_num === '') {
        this.$message({
          message: '请填写版本号',
          type: 'error'
        })
        return
      }
      if (this.formLabelAlign.file_url === '') {
        this.$message({
          message: '请上传文件',
          type: 'error'
        })
        return
      }
      console.log('this.formLabelAlign.file_url', this.formLabelAlign.file_url)
      if (this.type === 1) {
        const data = await createOta(this.formLabelAlign)
        this.$message({
          message: '新增成功',
          type: 'success'
        })
        this.$emit('updata')
        console.log('data', data)
      } else {
        const data = await updataOta({ ...this.formLabelAlign, id: this.id })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updata')
        console.log('data', data)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
